// TimelineSection.jsx (or inside AboutPage.jsx)

import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '../../ui/Badge';
import { Card, CardContent } from '../../ui/Card';

const TimelineSection = ({ timeline }) => {
  return (
    <section className="timeline-section py-5 bg-light-custom">
      <div className="container px-3">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-5"
        >
          <Badge className="badge-journey text-primary">Our Journey</Badge>
          <h2 className="display-5 fw-bold gradient-text mb-3">Company Timeline</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '800px' }}>
            From humble beginnings to industry leadership — here's how we've evolved over the years.
          </p>
        </motion.div>

        <div className="timeline-wrapper mx-auto">
          {timeline.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return (
              <motion.div
                key={item.year}
                initial={{ opacity: 0, x: isEven ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
                className={`timeline-item d-flex align-items-center mb-5 ${isEven ? 'layout-left' : 'layout-right'}`}
              >
                {isEven && (
                  <>
                    <div className="timeline-card-wrapper me-4">
                      <Card className="card-bg-custom border-0 shadow-lg rounded-xl fixed-width-card">
                        <CardContent className="p-4">
                          <Badge className="badge-year">{item.year}</Badge>
                          <h5 className="fw-semibold mt-2 mb-2">{item.title}</h5>
                          <p className="text-muted">{item.description}</p>
                        </CardContent>
                      </Card>
                    </div>
                    <div className="timeline-dot-wrapper flex-shrink-0">
                      <div className="timeline-dot bg-gradient-primary rounded-circle position-relative">
                        <div className="timeline-dot-ping rounded-circle position-absolute"></div>
                      </div>
                    </div>
                    <div className="flex-grow-1"></div>
                  </>
                )}
                {!isEven && (
                  <>
                    <div className="flex-grow-1"></div>
                    <div className="timeline-dot-wrapper flex-shrink-0">
                      <div className="timeline-dot bg-gradient-primary rounded-circle position-relative">
                        <div className="timeline-dot-ping rounded-circle position-absolute"></div>
                      </div>
                    </div>
                    <div className="timeline-card-wrapper ms-4">
                      <Card className="card-bg-custom border-0 shadow-lg rounded-xl fixed-width-card">
                        <CardContent className="p-4">
                          <Badge className="badge-year">{item.year}</Badge>
                          <h5 className="fw-semibold mt-2 mb-2">{item.title}</h5>
                          <p className="text-muted">{item.description}</p>
                        </CardContent>
                      </Card>
                    </div>
                  </>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
